// Client-side JSON/CSV question parsing — used while an exam/tema doesn't
// exist on the server yet (e.g. before the course/workshop is first saved),
// so import doesn't need to wait for a save round-trip. Mirrors the shape
// the backend's own import endpoint (`POST .../exams/{id}/import`) produces.

const parseCsvRows = (text) => {
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;
  let i = 0;
  const pushField = () => { row.push(field); field = ""; };
  const pushRow = () => { pushField(); rows.push(row); row = []; };
  while (i < text.length) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuotes = false; i += 1; continue;
      }
      field += c; i += 1; continue;
    }
    if (c === '"') { inQuotes = true; i += 1; continue; }
    if (c === ",") { pushField(); i += 1; continue; }
    if (c === "\r") { i += 1; continue; }
    if (c === "\n") { pushRow(); i += 1; continue; }
    field += c; i += 1;
  }
  if (field.length > 0 || row.length > 0) pushRow();
  return rows.filter((r) => r.length > 1 || (r.length === 1 && r[0] !== ""));
};

export const questionsFromCsvText = (text) => {
  const rows = parseCsvRows(text);
  if (rows.length < 2) return [];
  const header = rows[0].map((h) => h.trim().toLowerCase());
  const col = (name) => header.indexOf(name);
  const qi = col("question"), ti = col("type"), oi = col("options"), ci = col("correct"), bi = col("block");
  return rows
    .slice(1)
    .map((r) => {
      const type = ((ti >= 0 ? r[ti] : "") || "single").trim() || "single";
      let options = ((oi >= 0 ? r[oi] : "") || "").split("|").map((o) => o.trim()).filter(Boolean);
      if (type === "truefalse") options = ["True", "False"];
      const correct = ((ci >= 0 ? r[ci] : "") || "")
        .split(",")
        .map((x) => x.trim())
        .filter((x) => /^\d+$/.test(x))
        .map(Number);
      return {
        text: ((qi >= 0 ? r[qi] : "") || "").trim(),
        type,
        options,
        correct,
        block: ((bi >= 0 ? r[bi] : "") || "").trim(),
      };
    })
    .filter((q) => q.text);
};

export const questionsFromJsonText = (text) => {
  const data = JSON.parse(text);
  return (data.questions || []).map((q) => ({
    text: q.text || "",
    type: q.type || "single",
    options: q.options || [],
    correct: q.correct || [],
    block: q.block || "",
  }));
};
